"use strict";
const config = {
    production: {
        facebookAppId: '408885492509387',
        firebase: {
            apiKey: 'AIzaSyChGURkIPXNXQA5tg528_LdZjWDLjN_TaQ',
            authDomain: 'my-minutes-beta-2.firebaseapp.com',
            databaseURL: 'https://my-minutes-beta-2.firebaseio.com',
            storageBucket: 'my-minutes-beta-2.appspot.com',
            messagingSenderId: '98956424557',
        },
        sentry: {
            dsn: 'https://9d05ae52b7ef497e8ac6f3293d7d88ee@sentry.io/92072',
        },
    },
    development: {
        facebookAppId: '1160235637374365',
        firebase: {
            apiKey: 'AIzaSyAP4eRNHg8lNQCGWq0RfA-5_97p5wOYL6o',
            authDomain: 'my-minutes-development.firebaseapp.com',
            databaseURL: 'https://my-minutes-development.firebaseio.com',
            storageBucket: 'my-minutes-development.appspot.com',
            messagingSenderId: '209014318324',
        },
        sentry: {
            dsn: 'https://82084b4fca694863a924c20e2f7968ee@sentry.io/100619',
        },
    },
    test: {
        facebookAppId: '1160235637374365',
        firebase: {
            apiKey: 'AIzaSyAP4eRNHg8lNQCGWq0RfA-5_97p5wOYL6o',
            authDomain: 'my-minutes-development.firebaseapp.com',
            databaseURL: 'https://my-minutes-development.firebaseio.com',
            storageBucket: 'my-minutes-development.appspot.com',
            messagingSenderId: '209014318324',
        },
        sentry: {
            dsn: 'https://82084b4fca694863a924c20e2f7968ee@sentry.io/100619',
        },
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = config[process.env.NODE_ENV];



/** WEBPACK FOOTER **
 ** ./src/config.ts
 **/